import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useEditShelfNode from 'api/locationsCategories/useEditShelfNode';
import React, { useState } from 'react';

const EditShelfNodeModal = props => {
  const { guid, defaultName } = props;

  const [editLoading, editShelfNode] = useEditShelfNode();

  const [itemName, setItemName] = useState(defaultName);

  return (
    <Dialog
      open={props.show}
      onClose={() => {
        props.closeHandler();
        setItemName('');
      }}
      sx={{ direction: 'rtl' }}
    >
      <DialogTitle>آپدیت قفسه</DialogTitle>

      <DialogContent>
        <FormControl sx={{ m: 1, minWidth: 300 }}>
          <TextField
            autoFocus
            label="عنوان قفسه"
            variant="standard"
            value={itemName}
            onChange={e => setItemName(e.target.value)}
          />
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <LoadingButton
          variant="contained"
          color="primary"
          loading={editLoading}
          disabled={!itemName}
          onClick={() => editShelfNode(guid, itemName, props.refreshData)}
        >
          تایید
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="warning"
          loading={editLoading}
          onClick={() => {
            props.closeHandler();
            setItemName('');
          }}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditShelfNodeModal;
